/**
 * Banner informativo dismissible. Se cierra con ✕ y NO vuelve a aparecer
 * (guardado en localStorage con la key proporcionada).
 */
import { useState, useEffect } from 'react';
import { Info, X } from 'lucide-react';

const STORAGE_PREFIX = 'bookvia_banner_dismissed_';

export default function InfoBanner({ storageKey, text }) {
  const [dismissed, setDismissed] = useState(true); // start hidden until we check localStorage

  useEffect(() => {
    try {
      const isDismissed = window.localStorage.getItem(`${STORAGE_PREFIX}${storageKey}`) === '1';
      setDismissed(isDismissed);
    } catch {
      setDismissed(false);
    }
  }, [storageKey]);

  const handleDismiss = () => {
    try {
      window.localStorage.setItem(`${STORAGE_PREFIX}${storageKey}`, '1');
    } catch {
      /* ignore quota errors */
    }
    setDismissed(true);
  };

  if (dismissed) return null;

  return (
    <div className="mb-4 flex items-start gap-3 rounded-xl border border-[#fbdcd6] bg-[#fff5f2] px-4 py-3">
      <Info className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#F05D5E]" />
      <p className="flex-1 text-sm text-neutral-700">{text}</p>
      <button
        type="button"
        onClick={handleDismiss}
        className="text-neutral-400 transition-colors hover:text-neutral-700 focus:outline-none focus:ring-2 focus:ring-[#F05D5E]/30 rounded"
        data-testid={`info-banner-dismiss-${storageKey}`}
        aria-label="Cerrar aviso"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
